import { createContext } from "react";

export const VendorsContext = createContext({});
export const VendorDetailsContext = createContext({});
export const ProfileCreateContext = createContext({});
export const ProfileDetailsContext = createContext({});
export const InvitationContext = createContext({});
export const ForgotPasswordContext = createContext({});
export const HeaderContext = createContext({});
